import { Link, useSearchParams } from "react-router";
import { useLocale } from "../context/LanguageContext";

function resolveErrorMessage(t: (key: string) => string, code: string): string {
  const key = `oidc.error.codes.${code}`;
  const resolved = t(key);
  if (resolved === key) {
    return t("oidc.error.generic");
  }
  return resolved;
}

/**
 * Public page for IdP / OIDC failures: backend redirects with `?code=`.
 */
export function OidcErrorPage() {
  const [params] = useSearchParams();
  const { t } = useLocale();
  const code = params.get("code") ?? "INTERNAL_ERROR";
  const message = resolveErrorMessage(t, code);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-sm rounded-lg border border-border bg-card p-8 text-center shadow-sm">
        <h1 className="mb-2 text-xl font-bold text-foreground">
          {t("oidc.error.title")}
        </h1>
        <p className="mb-6 text-sm text-muted-foreground">{message}</p>
        <Link
          to="/login"
          replace
          className="inline-block rounded-lg bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground hover:opacity-90"
        >
          {t("oidc.error.backToLogin")}
        </Link>
      </div>
    </div>
  );
}
